import { SERVER_API_URL } from './../../app.constants';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { createRequestOption } from 'src/app/shared/util/request-util';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class FutureHistoryService {

  private resourceUrl = SERVER_API_URL + 'api/fetch-future-audit-logs-by-module-wise';


  constructor(private http: HttpClient) {

  }

  getFutureAuditLogByTypeForDataManagement(pageObject, form_data): Observable<any> {
    const options = createRequestOption(pageObject);
    return this.http.post<any>(SERVER_API_URL + 'api/fetch-future-record-logs', form_data, { params: options, observe: 'response' })
  }

  deleteFutureAuditLog(id: number, masterId: number, futureRecordTyep: string): Observable<any> {
    return this.http.delete<any>(SERVER_API_URL + 'api/delete-future-record' + `/${id}/${masterId}/${futureRecordTyep}`, { observe: 'response' });
  }
}
